<template>
  <div v-if="errors" class="row mt-3">
    <div class="col">
      <b-alert v-for="error in errors" :key="error" :show="true" variant="danger">
        {{ error }}
      </b-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Errors',
  props: {
    errors: {type: Array, required: true},
  },
}
</script>